import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Edit, Trash2 } from 'lucide-react';
import { LoadingState, EmptyState } from '@/components/shared';
import { Building2 } from 'lucide-react';
import { OrganizersManagerViewProps } from './organizersmanager.props';
import OrganizersFormDialog from './organizersmanager.form';

const OrganizersManagerView: React.FC<OrganizersManagerViewProps> = ({
  organizersList,
  loading,
  isDialogOpen,
  setIsDialogOpen,
  editingOrganizer,
  setEditingOrganizer,
  formData,
  setFormData,
  handleEdit,
  handleDelete,
  handleSubmit,
  deleteTarget,
  setDeleteTarget,
  confirmDelete,
}) => {
  return (
    <>
      <Card>
        <CardHeader>
          <div className="flex items-center justify-between">
            <CardTitle>Управување со организатори</CardTitle>
            <OrganizersFormDialog
              isDialogOpen={isDialogOpen}
              setIsDialogOpen={setIsDialogOpen}
              editingOrganizer={editingOrganizer}
              setEditingOrganizer={setEditingOrganizer}
              formData={formData}
              setFormData={setFormData}
              handleSubmit={handleSubmit}
              deleteTarget={deleteTarget}
              setDeleteTarget={setDeleteTarget}
              confirmDelete={confirmDelete}
            />
          </div>
        </CardHeader>
        <CardContent>
          {loading ? (
            <LoadingState />
          ) : (
            <div className="space-y-4">
              {organizersList.length === 0 ? (
                <EmptyState
                  icon={<Building2 className="w-10 h-10 text-muted-foreground" />}
                  message="Нема креирано организатори. Додајте го вашиот прв организатор."
                  action={{ label: 'Додај организатор', onClick: () => setIsDialogOpen(true) }}
                />
              ) : organizersList.map((organizer) => (
                <div key={organizer.id} className="flex items-center justify-between p-4 border border-border rounded-lg hover:bg-muted transition-colors">
                  <div className="flex items-center space-x-4">
                    <img src={organizer.logo} alt={organizer.name} className="w-16 h-16 rounded-full object-cover" />
                    <div>
                      <h4 className="font-semibold text-foreground">{organizer.name}</h4>
                      <p className="text-sm text-muted-foreground">{organizer.email}</p>
                      <p className="text-sm text-muted-foreground line-clamp-2">{organizer.description}</p>
                    </div>
                  </div>
                  <div className="flex space-x-2">
                    <Button variant="outline" size="sm" onClick={() => handleEdit(organizer)}><Edit className="w-4 h-4" /></Button>
                    <Button variant="outline" size="sm" onClick={() => handleDelete(organizer.id)} className="text-red-600 hover:text-red-700 hover:bg-red-50"><Trash2 className="w-4 h-4" /></Button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </CardContent>
      </Card>
    </>
  );
};

export default OrganizersManagerView;
